/*
 * Parent Theme Main JS
 * Note: Renamed _main.js as main.js is the entry file
 * for webpacking ONLY parent JS/CSS (not recommended)
 *
 * This file bootstraps the core JS functionality for the Unified theme.
 * It is imported into all child themes that use the Unified theme.
 *
 * NOTE - ADD YOUR LOGIC IN A SEPARATE FILE AND CALL YOUR FUNCTIONS HERE.
 * USE EXPORTS & IMPORTS!
 * DO NOT ADD THE BULK OF YOUR JS IN THIS FILE...OR ELSE! ;_;
 */

import { injectCmpFooterPrivacyLink } from '@s1/core/cmp-footer';
/*
 * APUB-1893: The web vitals script is costly and with the move to GA4
 * the value of the data is diminished as averaging the scores require BigQuery
 * which is another cost. We're opting to turn this feature off. This could potentially
 * be re-enabled for debug specific purposes in the future.
 *
 * import initWebVitals from '@s1/core/core-web-vitals';
 */

import initNewRelic from '@s1/core/new-relic';
import {
  loadOrganicTerms,
  unifiedFlexCtaCalc,
  unifiedFlexRSoCCalc,
  unifiedCalcCtaMaxSizeLauncher,
  unifiedCalcCtaMaxSize
} from '@s1/core/utilities';
import translateString from '@s1/core/translator';
import nav from './core/_nav';
import tabs from './core/_tabs';
import stickyHeader from './core/_sticky-header';
import scrollToTop from './core/_scroll-to-top';
import newsletterValidation from './core/_newsletter';
import hero from './core/_hero';
import zipWidget from './core/offers/_zipwidget';
import unifiedDarkModeToggle from './unified-dark-mode-toggle';
import serp from './serp';
import sendArticleCostToGa from './send-article-cost-to-ga';
import sendEstReadingTimeToGa from './send-est-reading-time-to-ga';
import sendSubheadingCountToGa from './send-subheading-count-to-ga';

require('./core/_alpine'); // initiate Alpine, set to window.s1.alpine

window.s1.translate_string = translateString;

// BlockInjector Helper functions
// Make loadOrganicTerms, flexCtaCalc, calcCtaMaxSizeLauncher, calcCtaMaxSize public
window.s1.loadOrganicTerms = loadOrganicTerms;
window.s1.unifiedFlexCtaCalc = unifiedFlexCtaCalc;
window.s1.unifiedFlexRSoCCalc = unifiedFlexRSoCCalc;
window.s1.unifiedCalcCtaMaxSizeLauncher = unifiedCalcCtaMaxSizeLauncher;
window.s1.unifiedCalcCtaMaxSize = unifiedCalcCtaMaxSize;

const main = () => {
  // Unified theme general items
  nav();
  tabs();
  stickyHeader();
  scrollToTop();
  newsletterValidation();
  hero.heroDescription();
  unifiedDarkModeToggle();

  // Google Analytics Events
  sendArticleCostToGa();
  sendEstReadingTimeToGa();
  sendSubheadingCountToGa();

  // Unified leadgen ad block-specific items
  zipWidget.init();

  // CTA block calc
  unifiedFlexCtaCalc();

  // RSoC block calc
  unifiedFlexRSoCCalc();

  // CMP/Unified tracker items
  injectCmpFooterPrivacyLink();
  initNewRelic();

  // serp template
  serp();
};

export default main;
